import { calcularNivelacion } from "./nivelacionEscrutinio";

// Motivos por los que una mesa aparece como "con problemas":
// - reconteo: los jurados marcaron el check al cerrar
// - descuadre: la suma del acta no coincide con la urna (se calcula)
// - sinFoto: se cerró sin cargar la foto del E-14
export const MOTIVOS_PROBLEMA = {
  reconteo: { etiqueta: "Reconteo solicitado", clase: "text-bg-danger", icono: "mdi:alert-octagon-outline" },
  descuadre: { etiqueta: "Acta no cuadra", clase: "text-bg-warning", icono: "mdi:scale-unbalanced" },
  sinFoto: { etiqueta: "Sin foto del E-14", clase: "text-bg-secondary", icono: "mdi:camera-off-outline" },
};

// escrutinio del listado (trae sumaCandidatos) -> [{ clave, detalle? }]
export const detectarProblemas = (escrutinio) => {
  const motivos = [];
  if (escrutinio.tieneProblema) {
    motivos.push({ clave: "reconteo" });
  }
  const { cuadra, novedades } = calcularNivelacion(escrutinio, [escrutinio.sumaCandidatos]);
  if (!cuadra) {
    motivos.push({ clave: "descuadre", detalle: novedades.join(" ") });
  }
  if (escrutinio.estado === "cerrado" && !escrutinio.tieneFoto) {
    motivos.push({ clave: "sinFoto" });
  }
  return motivos;
};

// enlace al Registro de votación con esa mesa ya cargada
export const rutaEscrutinio = ({ corporacion, lugar, mesa }) =>
  `/conteo?${new URLSearchParams({ corporacion, lugar, mesa })}`;

// enlace a la lista de mesas con un filtro (y el lugar/mesa activos en Resultados)
export const rutaMesas = (filtro, { lugar, mesa } = {}) => {
  const parametros = new URLSearchParams({ filtro });
  if (lugar) parametros.set("lugar", lugar);
  if (mesa) parametros.set("mesa", mesa);
  return `/mesas?${parametros}`;
};

// todas las mesas con sus motivos (lista vacía si no tiene problemas)
export const conMotivos = (escrutinios) =>
  escrutinios.map((escrutinio) => ({ ...escrutinio, motivos: detectarProblemas(escrutinio) }));

// filtros de la vista de mesas (/mesas?filtro=...), también usados por los
// indicadores de Resultados
export const FILTROS_MESA = [
  { clave: "escrutadas", etiqueta: "Escrutadas", cumple: () => true },
  { clave: "abiertas", etiqueta: "Abiertas", cumple: (mesa) => mesa.estado === "abierto" },
  { clave: "cerradas", etiqueta: "Cerradas", cumple: (mesa) => mesa.estado === "cerrado" },
  { clave: "problemas", etiqueta: "Con problemas", cumple: (mesa) => mesa.motivos.length > 0 },
  { clave: "sinFoto", etiqueta: "Sin foto", cumple: (mesa) => !mesa.tieneFoto },
];

// solo las mesas con al menos un motivo; primero las de reconteo
export const mesasConProblemas = (escrutinios) =>
  conMotivos(escrutinios)
    .filter((escrutinio) => escrutinio.motivos.length > 0)
    .sort((a, b) => Number(b.tieneProblema) - Number(a.tieneProblema));
